<template>
    <div class="position-relative">
        <div v-if="isLoggedIn">
            <a class="nav-link" :href="$ceres.urls.myAccount">
                <img alt="Account" :src="loggedInPic" width="19px" height="19px">
                <span class="d-none d-sm-inline">Konto</span>
            </a>
        </div>
        <div v-if="!isLoggedIn">
            <a class="nav-link" data-testing="login-select" v-if="showLogin" :href="isLogin ? 'javascript:void(0)' : '#login'"
               :data-toggle="isLogin ? false : 'modal'"
               @click="createLoginModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.login')">
                <i class="fa fa-user mr-1" aria-hidden="true"></i>
                <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.login") }}</span>
            </a>
            <template v-if="showRegistration">
                <span class="pipe" v-if="!showLogin"></span>
                <a class="nav-link" data-testing="register-select" :href="isRegister ? 'javascript:void(0)' : '#registration'" :data-toggle="isRegister ? false : 'modal'" @click="createRegisterModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.loginRegister')">
                    <i class="fa fa-user-plus mr-1" aria-hidden="true"></i>
                    <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginRegister") }}</span>
                </a>
            </template>
        </div>
    </div>
</template>

<script>
import ValidationService from 'ceres/app/services/ValidationService';
import {mapGetters, mapActions} from 'vuex';

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true,
        },
        loadCustomer: {
            type: Boolean,
            default: true,
        },
        showLogin: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        firstName() {
            let username = this.username;
            let arr = username.split(' ');
            return arr[0];
        },

        loggedInPic() {
            return App.pluginPathTheme + '/images/loggedin.PNG';
        },

        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
        };
    },

    methods: {
        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");
        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
